import { useState } from "react";
import { FontFa } from "../../../../components";
import { Checkbox, Table } from "antd";
import { documentStatus } from "../../../../constants";
import { TableHelpers } from "../../../../helper/TableHelper";
import { ColumnsType } from "antd/lib/table";

const getIcon = (docType: string) => {
  switch (docType) {
    case "doc":
    case "docx":
      return <FontFa name="faFileWord" size="lg" color={"#0F4C81"} />;
    case "pptx":
    case "ppt":
      return <FontFa name="faFilePowerpoint" size="lg" color={"#D04423"} />;
    case "xlsx":
      return <FontFa name="faFileExcel" size="lg" color={"#1d6f42"} />;
    case "pdf":
      return <FontFa name="faFilePdf" size="lg" color={"#B0171F"} />;
    default:
      return <FontFa name="faFileCode" size="lg" />;
  }
};

export const DocumentTableFormItem = ({ documentData, onChange, value }: any) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  const columns: ColumnsType<any> = [
    {
      title: "Tên tài liệu",
      dataIndex: "Title",
      render: (title: string, record: any) => (
        <div>
          {getIcon(record.type)} {title}
        </div>
      ),
      ...TableHelpers.searchInput({ dataIndex: "Title" }),
    },
    {
      title: "Loại tài liệu",
      dataIndex: "docType",
      width: 150,
    },
    {
      title: "Tình trạng",
      dataIndex: "docStatus",
      width: 150,
    },
  ];

  const handleSelect = (record: any, selected: any) => {
    if (selected) {
      setSelectedRowKeys((keys) => [...keys, record.id]);
      const values = !value ? [] : [...value];
      onChange([...values, record]);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.id);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
      const index = value.findIndex((e: any) => e.id === record.id);
      onChange([...value.slice(0, index), ...value.slice(index + 1)]);
    }
  };

  const toggleSelectAll = () => {
    setSelectedRowKeys((keys) => (keys.length === documentData.length ? [] : documentData.map((r: any) => r.id)));
    onChange(value?.length === documentData.length ? [] : documentData);
  };

  const headerCheckbox = (
    <Checkbox
      checked={!!selectedRowKeys?.length}
      indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < documentData.length}
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    getCheckboxProps: (record: any) => ({
      disabled: record.docStatusValue === documentStatus.publish.value, // Column configuration not to be checked
      name: record.name,
    }),
    selectedRowKeys: selectedRowKeys,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
  };

  return (
    <Table
      rowSelection={{
        type: "checkbox",
        preserveSelectedRowKeys: true,
        ...rowSelection,
      }}
      columns={columns}
      dataSource={documentData}
      bordered
      rowKey="id"
      showHeader
    />
  );
};
